import React, { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import success from "../../../src/waitlistDocVault/assets/images/success.png";
import failure from "../../../src/waitlistDocVault/assets/images/failure.png";
import { useEffect } from "react";
import { postDownloadApi } from "../../shared/service";
import PreviewModal from "../../shell/components/onboarding/PreviewModal";
import {getUploadedDocsList, submitDoucments } from "../../waitlist/services/waitlist-service";
import { get } from "lodash";
import { toast, ToastContainer } from "react-toastify";
import AddressPreview from "./AddressPreview";
import { useHistory } from "react-router-dom";
// import ReactPixel from 'react-facebook-pixel';
import { utils } from "../../core/helpers/utils";

const addressDocType = [
  'aadhaar', 
  'voterId', 
  'passport', 
  "address",
  "address_1",
  "aadhar",
];

const docList = [
  {
    type: 'pan',
    title: 'PAN',
    successText: 'PAN verified successfully',
    failureText: 'PAN verification failed',
    pendingText: 'PAN verification under process'
  },
  {
    type: 'address',
    title: 'KYC',
    successText: 'KYC verified successfully',
    failureText: 'KYC verification failed',
    pendingText: 'KYC verification under process'
  },
  {
    type: 'bank',
    title: 'Bank Account',
    successText: 'Bank account verified successfully',
    failureText: 'Bank account verification failed',
    pendingText: 'Bank account verification under process'
  },
  {
    type: 'demat',
    title: 'Demat Account',
    successText: 'Demat account verified successfully',
    failureText: 'Demat account verification failed',
    pendingText: 'Demat account verification under process'
  }
]

export default function KycDocStatus(props) {
  const [isMobile, setIsMobile] = useState(false);
  const { thirdPartyData, displayTab } = props;
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const [isAddress, setIsAddress] = useState(false);
  const [addressFiles, setAddressFile] = useState([]);
  const {errors, isKycDone, isDocPresent} = props;
  const history = useHistory();
  const [isPdf, setIsPdf] = useState(false);

  
  const getUploadedDocs = () => {
    getUploadedDocsList(
      { payload: utils.encryptedPayload(get(thirdPartyData, "pan", "")) }, 
      {"X-product": `orobonds:default`}
    ).then((result) => {
      const docsList = utils.parsePayload(result);
      if (docsList && docsList.success) {
        setUploadedDocs(get(docsList, "data", []));        
      }
    });
  }

  const toggleAddress = () => {
    setIsAddress(!isAddress);
  }

  useEffect(() => {
    // ReactPixel.init('1613991859107974');
    props.setReupload(false);
    let mobile = window.matchMedia("(max-width: 768px").matches;
    setIsMobile(mobile);
    getUploadedDocs();
  }, []);

  const closePreview = () => {
    setIsPreviewOpen(!isPreviewOpen);
  }

  const getDocs = (filename) => {
    const _url = "/users/v2/downloadDocs";
    const payload = {
      filename: filename,
    };
    postDownloadApi(_url, payload).then((fileResponse) => {
      if (!fileResponse || fileResponse.err) {
        toast.error(
          fileResponse.msg || "Not able to fetch data. Please try again"
        );
        return;
      }
      let tempFilenameArr= filename.split('.');
      let ispdf = tempFilenameArr[tempFilenameArr.length - 1] === 'pdf' ? true : false;
      setIsPdf(ispdf);
      setPreviewData(URL.createObjectURL(fileResponse));
    });
  }

  const determinePopupCta = (type) => {
    let ctaText = 'Upload';
    if (isKycDone) {
      switch (type) {
        case 'demat':
        case 'pan':
          ctaText = 'Preview';
          break;
        case 'address':
          ctaText = 'Preview';
          break;
        case 'bank':        
          ctaText = null;
          break;
        default:
          ctaText = null;
      }
    } else {
      switch (type) {
        case 'demat':
        case 'bank':
        case 'pan':
          ctaText = 'Edit';
          break;
        case 'address':
          ctaText = 'Preview / Upload';
          break;
      }
    }
    if (ctaText) {
      return (
        <Button onClick={() => displayTab(type)}>
          {ctaText}
        </Button>
      )
    }
  }

  const showEditTab = (type) => {
    props.setReupload(true);
    displayTab(type);
  }

  const getDocsStateCard = () => {
    return docList.map((item, index) => {
      let condition = true;
      if (isDocPresent(item.type)) {
        if (item.type === 'pan') {
         condition = errors && errors.filter (e => e.type === item.type || e.type === 'poi').length;
        } else if (item.type !== 'address') {
          condition = errors && errors.filter(e => e.type === item.type).length;
        } else {
          condition = errors.find(e => addressDocType.includes(e.type)) &&
          errors.find(e => addressDocType.includes(e.type)).remarks;

        }
      }
      return (
        <Col lg={5} className={isMobile ? "mb-3" : "mb-4  "}>
          <div className="d-flex flex-row">
            {isKycDone ? (
              <img
                src={success}
                className="success-img"
                alt="success img"
              />
            ) : 
            condition ? (
              <img
                src={failure}
                className="success-img"
                alt="failure img"
              />
            ) : (
              <img
                src={success}
                className="success-img"
                alt="pending img"
              />
            )}
            <div className="ml-4">
              <p className="title">{item.title}</p>
              {isKycDone ? (
                <p className="subtext">{item.successText}</p>
              ) : condition ? (
                <p className="subtext">{item.failureText}</p>
              ) : (
                <p className="subtext">{item.pendingText}</p>
              )}
            </div>
          </div>
          <div className="menu">
            <Button onClick={() => displayPreviewData(item.type)}>
              Preview
            </Button>
            {!isKycDone ? (<Button onClick={() => showEditTab(item.type)}>
              Edit
            </Button>) : null}
          </div>
        </Col>
      );      
    });
  }

  const displayPreviewData = (type) => {    
    displayTab(type);
  };

  const submitUserDoucments = () => {
    submitDoucments({"X-product": `orobonds:default`})
    .then(res => {
      if(!res || !res.success) {
        return;
      } else {
        props.reload();
        // ReactPixel.track('KYC APPROVED');
      }
    });
  };

  return (
    <div className="sub-fold second-fold pt-1 flex-column">
      <Row className="second-row">
        {getDocsStateCard()}
      </Row>
      <div className="explore text-center mb-3">
        <Button
          className="explore-btn" 
          color="secondary" 
          onClick={() => {
            if (isKycDone) {
              if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({ action: "GO_BACK", data: "dashboard" })
                )
              } else {
                history.replace('/biddeasy-dashboard');
              }
            } else {
              submitUserDoucments();
            }
            
          }}
          outline
        >
          {console.log("here",isKycDone)}
          {isKycDone ? "Start investing" : "Click to Complete KYC"}
        </Button>
      </div>
      {isPreviewOpen ?
        <PreviewModal 
          close={closePreview}
          isOpen={isPreviewOpen}
          preview={previewData}
          isPdf={isPdf}
        />
      : null }
      {isAddress ?
        <AddressPreview 
        isOpen={isAddress}
        toggle={toggleAddress}
        address={addressFiles}
      /> : null}

      {/* {!isMobile && 
        <div className="explore text-center">
          <Button className="explore-btn" 
                  color="secondary" 
                  onClick={() => {
                            history.replace("/orobonds-asset");
                          }}
                  outline>
                    Start investing
          </Button>
        </div>
      } */}

      <ToastContainer />
    </div>
  );
}